var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlbum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_1042)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M4.06176 19.873V11.3926C4.06176 8.58798 6.36733 6.31445 9.17188 6.31445H6.22656C3.42202 6.31445 1.14844 8.58798 1.14844 11.3926V19.873C1.14844 22.6776 3.42202 24.9512 6.22656 24.9512H9.17188C6.36733 24.9512 4.06176 22.6776 4.06176 19.873Z",
    fill: "url(#paint0_linear_185_1042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 25.9902H6.09375C2.73366 25.9902 0 23.2566 0 19.8965V11.5684C0 8.20827 2.73366 5.47461 6.09375 5.47461H19.9062C23.2663 5.47461 26 8.20827 26 11.5684V19.8965C26 23.2566 23.2663 25.9902 19.9062 25.9902ZM6.09375 7.50586C3.85369 7.50586 2.03125 9.3283 2.03125 11.5684V19.8965C2.03125 22.1365 3.85369 23.959 6.09375 23.959H19.9062C22.1463 23.959 23.9688 22.1365 23.9688 19.8965V11.5684C23.9688 9.3283 22.1463 7.50586 19.9062 7.50586H6.09375Z",
    fill: "url(#paint1_linear_185_1042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4664 20.4782C17.0736 20.0344 17.3713 19.2996 17.2432 18.5606L17.0303 17.3314L17.9344 16.459C18.4776 15.9348 18.6713 15.1638 18.4399 14.447C18.2071 13.7263 17.5949 13.2113 16.8421 13.1031L15.5842 12.9221L15.0235 11.7975C14.3267 10.3512 12.1817 10.3515 11.4851 11.7975L10.9244 12.9221L9.66648 13.103C8.91365 13.2113 8.30148 13.7263 8.06875 14.4469C7.83729 15.1638 8.03097 15.9347 8.57423 16.4589L9.47834 17.3313L9.26536 18.5606C9.13734 19.2995 9.43502 20.0343 10.0422 20.4782C10.6547 20.9259 11.4535 20.9864 12.1269 20.636L13.2542 20.0492L14.3817 20.636C15.0521 20.9853 15.8521 20.9274 16.4664 20.4782ZM12.3389 18.2357L11.2883 18.7824L11.4863 17.6398C11.6813 16.3857 10.8666 15.8664 10.0857 15.0949L11.2413 14.9287C12.5026 14.7269 12.7485 13.7815 13.2542 12.8014L13.7805 13.8572C14.3646 14.9827 15.3378 14.9246 16.4227 15.095L15.5935 15.8951C14.6913 16.7959 15.0457 17.6959 15.2201 18.7825L14.1695 18.2357C13.8868 18.0888 13.5729 18.012 13.2542 18.012C12.9356 18.012 12.6217 18.0887 12.3389 18.2357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24219 4.05238C8.68126 4.05238 8.22656 3.59768 8.22656 3.03675C8.22656 2.47674 7.77095 2.02113 7.21094 2.02113C6.65092 2.02113 6.19531 2.47674 6.19531 3.03675C6.14611 4.3819 4.21357 4.38261 4.16406 3.03675C4.31732 -0.999949 10.1053 -0.998528 10.2578 3.0368C10.2578 3.59768 9.80312 4.05238 9.24219 4.05238ZM21.9375 3.03675C21.7842 -0.999949 15.9962 -0.998528 15.8438 3.0368C15.894 4.38281 17.8253 4.38205 17.875 3.03675C17.875 2.47674 18.3306 2.02113 18.8906 2.02113C19.4506 2.02113 19.9062 2.47674 19.9062 3.03675C19.9555 4.3819 21.888 4.38261 21.9375 3.03675Z",
    fill: "url(#paint2_linear_185_1042)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_185_1042",
    x1: 1.14844,
    y1: 6.31445,
    x2: 15.2604,
    y2: 14.6786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_185_1042",
    x1: 0,
    y1: 5.47461,
    x2: 15.2801,
    y2: 32.1344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_185_1042",
    x1: 4.16406,
    y1: 0.00976562,
    x2: 5.28646,
    y2: 6.80337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_1042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbum);
export default __webpack_public_path__ + "static/media/album.e923a886526ac4f8fce1f48903cdefdb.svg";
export { ForwardRef as ReactComponent };